<template lang="pug">
ul.value-props(role="list")
  li.value-prop.xs-4.text-center(v-for="(valueProp, index) in cmsValuePropsMapped" :key="valueProp.text + index")
    template
      ImgBox.value-prop-icon(
        :media-obj="valueProp.iconV2"
        :fill="false"
        v-if="isIconV2(valueProp)"
      )
      .image-wrap(v-else)
        .a-box-xs-1x1
          .a-box-content
            ImgBox(:media-obj="valueProp.icon")
    span.value.bold.xs-f-xxsmall.md-f-xsmall.xl-f-small {{ valueProp.text }}
</template>

<script>
  import { mapState } from 'vuex';
  import ImgBox from "@components/imgBox";

  export default {
    name: "ValueProps",

    components: {
      ImgBox,
    },

    props: {
      product: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      ...mapState('cms', ['cmsSettings']),

      valueProps() {
        return this.cmsSettings?.valueProps || [];
      },
      
      cmsValuePropsMapped() {
        const mappedValueProps = [];
        for (const valueProp of this.valueProps) {
          const valuePropToRender = {
            iconV2: valueProp.iconV2,
            icon: valueProp.icon,
            text: valueProp.staticText,
          };
          if (valueProp?.mapByProductField) {
            const productValue = this.product[valueProp.mapByProductField];
            if (productValue) {
              const match = valueProp.valuesForProductField.find(
                (vp) => vp.value === productValue
              );
              if (match) {
                valuePropToRender.text = match.text;
              }
            }
          }
          mappedValueProps.push(valuePropToRender);
        }
        return mappedValueProps;
      },
    },

    methods: {
      isIconV2(valueProp) {
        return valueProp?.iconV2?.icon;
      },
    },
  };
</script>

<style lang="stylus" scoped>
.value-props
  list-style none
  padding 0
  margin 0
  display flex
  flex-direction row
  gap 1rem
  width 100%
  margin 1.38em 0

  @media mq-mobile
    padding 0 0.2em

  .value-prop
    display flex
    flex-direction column
    align-items center

  .value-prop-icon
    color brand-color-1

  .image-wrap
    width 1.9em
    height 1.9em

  .value
    margin-top 0.7em
    color brand-color-1
</style>
